<template>
  <div class="container-fluid py-4">

  
     <!-- Header moderne -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-clinique">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-building fs-2 text-primary"></i>
        <h2 class="fw-bold mb-0">Lits</h2>
      </div>
      <button class="btn btn-primary btn-lg shadow-sm btn-clinique" @click="creation()">
        <i class="bi bi-plus-circle me-1"></i> Nouveau Lit
      </button>
    </div>

    <!-- Formulaire moderne -->
    <div class="card p-4 shadow-sm rounded card-clinique">

      <div class="row g-3 mb-3">
        <!-- Numéro du lit -->
        <div class="col-md-6">
          <label for="numero" class="form-label fw-semibold">Numéro du lit</label>
          <input
            type="text"
            id="numero"
            v-model="lit.numero"
            class="form-control form-control-clinique"
            :class="{ 'is-invalid': error.numero }"
            placeholder="Ex : LIT-01"
          >
          <div class="invalid-feedback">{{ error.numero }}</div>
        </div>

        <!-- Chambre associée -->
        <div class="col-md-6">
          <label for="chambre" class="form-label fw-semibold">Chambre</label>
          <select
            id="chambre"
            v-model="lit.chambreId"
            class="form-select form-select-clinique"
            :class="{ 'is-invalid': error.chambreId }"
          >
            <option value="">-- Sélectionner une chambre --</option>
            <option v-for="chambre in chambres" :key="chambre.id" :value="chambre.id">
              {{ chambre.numero }} - {{ chambre.type.nom }}
            </option>
          </select>
          <div class="invalid-feedback">{{ error.chambreId }}</div>
        </div>
      </div>

      <!-- Statut -->
      <div class="form-check form-switch mb-3">
        <input
          class="form-check-input"
          type="checkbox"
          id="enabled"
          v-model="lit.isEnabled"
        >
        <label class="form-check-label fw-semibold" for="enabled">Activé ?</label>
      </div>

      <!-- Boutons -->
      <div class="d-flex justify-content-end gap-3 mt-4">
        <button class="btn btn-light border shadow-sm px-4 py-2" @click="cancel">
          <i class="bi bi-x-circle me-1"></i> Annuler
        </button>
        <button class="btn btn-success shadow px-4 py-2 btn-clinique" :disabled="isLoading" @click="saveLit">
          <i class="bi bi-save me-1"></i>
          <span v-if="isLoading">Chargement...</span>
          <span v-else>Enregistrer</span>
        </button>
      </div>

    </div>

  </div>
</template>

<script>
import api from '@/api';

export default {
  data() {
    return {
      isLoading: false,
      chambres: [],
      lit: {
        numero: '',
        chambreId: '',
        isEnabled: true
      },
      error: {
        numero: '',
        chambreId: ''
      }
    };
  },
  methods: {
    async fetchChambres() {
      try {
        const response = await api.getItems('chambres');
        this.chambres = response.data.data || [];
      } catch (error) {
        console.error('Erreur lors de la récupération des chambres', error);
      }
    },
    validateForm() {
      this.error = {
        numero: this.lit.numero ? '' : 'Le numéro est requis',
        chambreId: this.lit.chambreId ? '' : 'La chambre est requise'
      };
      return !Object.values(this.error).some(err => err !== '');
    },
    async saveLit() {
      if (!this.validateForm() || this.isLoading) return;
      try {
        this.isLoading = true;
        const payload = {
          numero: this.lit.numero,
          chambre: this.lit.chambreId,
          isEnabled: this.lit.isEnabled
        };
        await api.createItem('lits', payload);
        //alert('Lit créé avec succès !');
        this.$router.push({ name: 'liste_lit' });
      } catch (error) {
        console.error('Erreur lors de la création du lit', error);
        alert("Une erreur s'est produite lors de l'enregistrement.");
      } finally {
        this.isLoading = false;
      }
    },
    cancel() {
      this.$router.push({ name: 'liste_lit' });
    }
  },
  created() {
    this.fetchChambres();
  }
};
</script>

<style scoped>
.header-clinique {
  padding: 15px 20px;
  background-color: #e9f5ff;
  border-radius: 12px;
  margin-bottom: 20px;
}

.card-clinique {
  background: #f8fafd;
  border-radius: 12px;
  border: none;
}

.form-control-clinique, .form-select-clinique {
  border-radius: 10px;
  border: 1px solid #d1e3f0;
  padding: 8px 12px;
  transition: all 0.3s ease;
}
.form-control-clinique:focus, .form-select-clinique:focus {
  box-shadow: 0 0 6px #0d6efd33;
  border-color: #0d6efd;
}

.btn-clinique {
  background: linear-gradient(90deg, #0d6efd, #6610f2);
  border: none;
  color: #fff;
  border-radius: 10px;
  transition: all 0.3s ease;
}
.btn-clinique:hover {
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
  transform: translateY(-2px);
}

.btn-clinique-outline {
  border-radius: 10px;
  border: 1px solid #d1e3f0;
  color: #0d6efd;
  background: #fff;
  transition: all 0.3s ease;
}
.btn-clinique-outline:hover {
  background-color: #e9f5ff;
  color: #0d6efd;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}
</style>
